import { render } from "./EmailChangePage.pug?vue&type=template&id=2c7ae1b7&lang=pug"
import script from "./EmailChangePage.js?vue&type=script&lang=js"
export * from "./EmailChangePage.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__